/**
 * DownloadingItemCard - Shows download progress for an item
 */

import { Loader2, Check, X, Image, Film, Music } from "lucide-react";

import { DownloadingMedia } from "@/types/media-library-panel.types";
import { cn } from "@/lib/utils";

interface DownloadingItemCardProps {
  item: DownloadingMedia;
}

export function DownloadingItemCard({ item }: DownloadingItemCardProps) {
  const TypeIcon =
    item.type === "video" ? Film : item.type === "audio" ? Music : Image;

  return (
    <div className="flex items-center gap-2 p-2 bg-muted/50 rounded-md">
      {/* Thumbnail or type icon (audio has no image thumbnail) */}
      <div className="w-10 h-10 rounded bg-muted flex items-center justify-center overflow-hidden flex-shrink-0">
        {item.thumbnailUrl && item.type !== "audio" ? (
          <img
            src={item.thumbnailUrl}
            alt={item.filename}
            className="w-full h-full object-cover"
          />
        ) : (
          <TypeIcon className="w-4 h-4 text-muted-foreground" />
        )}
      </div>

      {/* Info */}
      <div className="flex-1 min-w-0">
        <p className="text-xs font-medium truncate">{item.filename}</p>
        <p className="text-[10px] text-muted-foreground capitalize">
          {item.provider} - {item.type}
        </p>
      </div>

      {/* Status */}
      <div className="flex-shrink-0">
        {item.status === "downloading" && (
          <Loader2 className="w-4 h-4 text-primary animate-spin" />
        )}
        {item.status === "completed" && (
          <div className="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center">
            <Check className="w-3 h-3 text-white" />
          </div>
        )}
        {item.status === "failed" && (
          <div className="w-5 h-5 rounded-full bg-destructive flex items-center justify-center">
            <X className="w-3 h-3 text-white" />
          </div>
        )}
      </div>
    </div>
  );
}
